import { Switch } from 'antd'
import { useCallback } from 'react'

export type SwitchProps = {
  onChange?: any
}
const BaseSwich = (props: SwitchProps) => {
  const { onChange } = props

  const handleChange = useCallback(
    (value) => {
      onChange && onChange(value)
    },
    [onChange],
  )
  return <Switch defaultChecked onChange={handleChange} />
}

export default BaseSwich
